module.exports = new __parcel__URL__("waves-2.a99ba250.webm").toString();